// extracted by mini-css-extract-plugin
export default {"b":"row1_b__MwVtt","l":"row1_l__AaH+g","details":"row1_details__x9+32","h":"row1_h__6gBYT","s":"row1_s__8D82C","r":"row1_r__fE3lJ","tx":"row1_tx__0YW3q","icon":"row1_icon__HIff3"};